import type { Entry } from '@libs/contentful';

export enum VetRxCategory {
    COLD = 'Cold Items',
    RX = 'Pharmacy',
    VET = 'Veterinary Diets',
}

export type VetRxInfo = Array<
    Entry<{
        title: string;
    }>
>;
